import styled from 'styled-components'

export const Label = styled.label`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  flex: ${({ flexWeight = 1 }) => flexWeight};
`

export const TextLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
`

export const Input = styled.input`
  box-shadow: ${({ isRequiredError }) =>
    isRequiredError && '0 0 0.15rem 0.05rem red'};
  &:focus {
    outline: none;
    box-shadow: ${({ isRequiredError }) =>
      isRequiredError && '0 0 0.3rem 0.1rem red'};
  }
  width: 100%;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;

  &[type='date']:invalid {
    color: #757575;
  }

  &:read-only {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: 2px solid #2962ff;
  }
`

export const Error = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: red;
`
